import { Link, useLocation } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useState, useEffect } from "react";
import { useCart } from "../context/CartContext";


const links = [
  { to: "/", label: "Home" },
  { to: "/story", label: "Our Story" },
  { to: "/collection", label: "Collection" },
  { to: "/contact", label: "Contact" },
];

export const Header = () => {
  const { count, setOpen } = useCart();
  const { pathname } = useLocation();
  const [mobile, setMobile] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => setMobile(false), [pathname]);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? "bg-mj-bg/85 backdrop-blur-xl border-b border-mj-border" : "bg-transparent"}`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <nav className="hidden md:flex items-center gap-8 flex-1">
          {links.slice(0, 2).map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase().replace(" ", "-")}`}
              className={`overline mj-link-underline text-mj-text ${pathname === l.to ? "text-mj-red" : ""}`}>
              {l.label}
            </Link>
          ))}
        </nav>

        <Link to="/" data-testid="logo-link" className="flex-1 md:flex-none flex items-center justify-center">
          <span className="sr-only">Manjaadii — Home</span>
        </Link>

        <div className="hidden md:flex items-center gap-8 flex-1 justify-end">
          {links.slice(2).map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase().replace(" ", "-")}`}
              className={`overline mj-link-underline text-mj-text ${pathname === l.to ? "text-mj-red" : ""}`}>
              {l.label}
            </Link>
          ))}
          <button data-testid="open-cart-btn" onClick={() => setOpen(true)} className="relative">
            <ShoppingBag className="w-5 h-5 text-mj-text" strokeWidth={1.4} />
            {count > 0 && (
              <span data-testid="cart-count" className="absolute -top-2 -right-2 bg-mj-red text-mj-bg text-[0.6rem] w-4 h-4 flex items-center justify-center rounded-full">{count}</span>
            )}
          </button>
        </div>

        <div className="flex md:hidden items-center gap-5">
          <button data-testid="open-cart-btn-mobile" onClick={() => setOpen(true)} className="relative">
            <ShoppingBag className="w-5 h-5" strokeWidth={1.4} />
            {count > 0 && <span className="absolute -top-2 -right-2 bg-mj-red text-mj-bg text-[0.6rem] w-4 h-4 flex items-center justify-center rounded-full">{count}</span>}
          </button>
          <button data-testid="mobile-menu-btn" onClick={() => setMobile(!mobile)}>
            {mobile ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {mobile && (
        <div data-testid="mobile-menu" className="md:hidden bg-mj-bg border-b border-mj-border px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <Link key={l.to} to={l.to} className="font-serif-mj text-2xl text-mj-text">{l.label}</Link>
          ))}
        </div>
      )}
    </header>
  );
};
